import React, { useEffect, useState } from 'react';
import { getActionMeta, formatMoney } from '../data/taskMeta';
import API_CONFIG from '../config/api';

// "Top tasks" card for the horizontal ranking rail.
// Periodically floats a +$ reward chip out of the image's bottom-right corner —
// the little earnings pulse real task apps use to keep the feed feeling alive.
const TopTaskCard = ({ task, rank, onClick }) => {
  const { Icon: ActionIcon } = getActionMeta(task.actionType);
  const disabled = task.remainingQuota <= 0 && !task.inProgress;

  const [burst, setBurst] = useState(null);
  useEffect(() => {
    let hideT, nextT;
    const loop = () => {
      // Random cadence per card so the rail never pulses in lockstep.
      nextT = setTimeout(() => {
        setBurst({ id: Date.now(), text: `+${formatMoney(task.reward)}` });
        hideT = setTimeout(() => setBurst(null), 1600);
        loop();
      }, 2200 + Math.random() * 3800);
    };
    loop();
    return () => { clearTimeout(nextT); clearTimeout(hideT); };
  }, [task.reward]);

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onClick(); }}
      className={`relative w-[150px] shrink-0 text-left bg-white rounded-lg border border-black/[0.05] overflow-hidden transition-all
        ${disabled ? 'opacity-55' : 'active:scale-[0.97]'}`}
    >
      <div className="relative h-[110px]">
        <img
          src={API_CONFIG.getImageUrl(task.imageUrl)}
          alt={task.title}
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        {rank > 0 && (
          <span className="absolute top-2 left-2 min-w-[20px] h-5 flex items-center justify-center rounded bg-black/55 px-1.5 text-[10px] font-extrabold text-white tabular">
            {rank}
          </span>
        )}
        <span className="absolute bottom-2 left-2 rounded bg-money px-1.5 py-0.5 text-[11px] font-extrabold text-white tabular">
          +{formatMoney(task.reward)}
        </span>
        {burst && (
          <span
            key={burst.id}
            className="animate-money-burst absolute bottom-2 right-2 text-[12px] font-extrabold text-money tabular drop-shadow-[0_1px_2px_rgba(0,0,0,0.45)] pointer-events-none"
          >
            {burst.text}
          </span>
        )}
      </div>

      <div className="p-2.5">
        <p className="text-[12.5px] font-bold text-ink leading-snug line-clamp-2 min-h-[32px]">
          {task.title}
        </p>
        <p className="mt-1 flex items-center gap-1 text-[11px] text-ink-muted min-w-0">
          <ActionIcon className="w-3 h-3 shrink-0" />
          <span className="truncate">{task.category || task.platform}</span>
        </p>
      </div>
    </div>
  );
};

export default TopTaskCard;
